// src/index.ts
import {
  Environment,
  Network,
  QueryResponseCache,
  RecordSource,
  Store
} from "relay-runtime";
var networkFetch = async (request, variables, apiUrl) => {
  const response = await fetch(apiUrl, {
    body: JSON.stringify({
      query: request.text,
      variables
    }),
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    },
    method: "POST"
  });
  return await response.json();
};
var createFetchResponse = (options) => {
  const { apiUrl, cacheSize, cacheTtl, latencyRetentionCount, recentFetchLatencyList } = options;
  const responseCache = new QueryResponseCache({
    size: cacheSize,
    ttl: cacheTtl
  });
  return async (parameters, variables, cacheConfig) => {
    const isQuery = parameters.operationKind === "query";
    const cacheKey = parameters.id ?? parameters.cacheID;
    const shouldUseCache = !(cacheConfig.force ?? false);
    if (isQuery && shouldUseCache) {
      const cacheResponse = responseCache.get(cacheKey, variables);
      if (cacheResponse != null) {
        return cacheResponse;
      }
    }
    const fetchStart = performance.now();
    const fetchResponse = await networkFetch(parameters, variables, apiUrl);
    const fetchEnd = performance.now();
    recentFetchLatencyList.push(fetchEnd - fetchStart);
    if (recentFetchLatencyList.length > latencyRetentionCount) {
      recentFetchLatencyList.shift();
    }
    return fetchResponse;
  };
};
var createEnvironment = (options) => {
  const { apiUrl, cacheSize = 100, cacheTtl = 5e3, latencyRetentionCount = 100 } = options;
  const recentFetchLatencyList = [];
  return new Environment({
    isServer: false,
    network: Network.create(
      createFetchResponse({
        apiUrl,
        cacheSize,
        cacheTtl,
        latencyRetentionCount,
        recentFetchLatencyList
      })
    ),
    options: { recentFetchLatencyList },
    store: new Store(RecordSource.create())
  });
};
export {
  createEnvironment
};
